import React from "react"
import Head from "next/head"
import { DefaultSiteName } from "../../libs/vars/system"

type Props = {
  children?: React.ReactNode
}

export default function LayoutLoading({ children }: Props) {
  return (
    <React.Fragment>
      <Head>
        <title>{DefaultSiteName}</title>
        <meta charSet="utf-8" />
        <meta name="viewport" content="initial-scale=1.0, width=device-width" />
      </Head>

      <div className="mx-auto max-w-3xl px-6 py-2 text-center">{children}</div>
    </React.Fragment>
  )
}
